<div class="form-container">
  <form class="form" [formGroup]="form" (ngSubmit)="submit(); submited = true;">
    <div class="form-toolbar">
      <div class="checkbox-container">
        <div class="trip-type-options" aria-label="Tipo de viagem">
          <mat-checkbox color="primary"
            [checked]="currentlyChecked === CheckboxOption.ONE_WAY"
            (change)="selectCheckbox(CheckboxOption.ONE_WAY)">
            Somente Ida
          </mat-checkbox>

          <mat-checkbox color="primary"
            [checked]="currentlyChecked === CheckboxOption.ROUND_TRIP"
            (change)="selectCheckbox(CheckboxOption.ROUND_TRIP)">
            Ida e Volta
          </mat-checkbox>
        </div>

        @if (submited && form.controls.option.errors?.required) {
          <app-error-form>Marque uma opção.</app-error-form>
        }
      </div>
    </div>

    <div class="search-fields">
      <div class="search-field search-field--airport search-field--origin">
        <label class="field-label" for="airport-origin">Origem</label>
        <input id="airport-origin" class="input-autocomplete aeroport-origin"
          type="text"
          placeholder="Cidade ou aeroporto"
          formControlName="airportOrigin"
          [matAutocomplete]="autoAirportOrigin">
        <mat-autocomplete #autoAirportOrigin="matAutocomplete">
          @for (airport of filteredAirportsOrigin | async; track airport) {
            <mat-option [value]="airport.airportInfo.iataCode">
              <div class="autocomplete-selection">
                <span>{{ airport.city.name }} - <strong>{{ airport.airportInfo.iataCode }}</strong></span>
                <span class="airport-name">{{ airport.airportInfo.name }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>

        @if (submited && form.controls.airportOrigin.errors?.required) {
          <app-error-form>Informe a Origem.</app-error-form>
        }
      </div>

      <button type="button" class="route-swap" (click)="swapRoute()"
        [disabled]="!form.value.airportOrigin && !form.value.airportDestiny"
        aria-label="Inverter origem e destino" title="Inverter origem e destino">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M7 16V4M7 4L3 8M7 4l4 4M17 8v12M17 20l4-4M17 20l-4-4"/>
        </svg>
      </button>

      <div class="search-field search-field--airport search-field--destination">
        <label class="field-label field-label--destination" for="airport-destiny">Destino</label>
        <input id="airport-destiny" class="input-autocomplete aeroport-destiny"
          type="text"
          placeholder="Cidade ou aeroporto"
          formControlName="airportDestiny"
          [matAutocomplete]="autoAirportDestiny">
        <mat-autocomplete #autoAirportDestiny="matAutocomplete">
          @for (airport of filteredAirportsDestiny | async; track airport) {
            <mat-option [value]="airport.airportInfo.iataCode">
              <div class="autocomplete-selection">
                <span>{{ airport.city.name }} - <strong>{{ airport.airportInfo.iataCode }}</strong></span>
                <span class="airport-name">{{ airport.airportInfo.name }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>

        @if (submited && form.controls.airportDestiny.errors?.required) {
          <app-error-form>Informe o Destino.</app-error-form>
        }
        @if (submited && form.errors?.routeInvalid) {
          <app-error-form>A Origem e o Destino não pode ser igual.</app-error-form>
        }
        @if (form.hasError('invalidOption')) {
          <app-error-form>Rotas internacionais não permitidas</app-error-form>
        }
      </div>

      <div class="search-fields__schedule">
        <div class="search-field search-field--dates">
          <div class="input-date_group">
            <div class="calendar-icon" aria-hidden="true">
              <img src="assets/images/calendar.svg" alt="">
            </div>

            <div class="input-date_item dt-departure">
              <span class="input-date_label" (click)="pickerDtDeparture.open()">Data da ida</span>
              <input formControlName="dtDeparture" placeholder="Ida"
                aria-label="Data da ida"
                matInput [matDatepicker]="pickerDtDeparture"
                (click)="pickerDtDeparture.open()" [min]="minDate" [max]="maxDateOutbound"/>
              <mat-datepicker #pickerDtDeparture></mat-datepicker>
            </div>

            <span class="input-date_group-line" aria-hidden="true"></span>

            <div class="input-date_item" [class.disable]="currentlyChecked !== CheckboxOption.ROUND_TRIP">
              <span class="input-date_label" (click)="pickerDtArrival.open()">Data da volta</span>
              <input formControlName="dtArrival" placeholder="Volta"
                aria-label="Data da volta"
                matInput [matDatepicker]="pickerDtArrival"
                (click)="pickerDtArrival.open()" [min]="minDate" [max]="maxDateInbound"/>
              <mat-datepicker #pickerDtArrival></mat-datepicker>
            </div>
          </div>

          @if (submited && form.controls.dtDeparture.errors?.required) {
            <app-error-form>Informe a data de Ida.</app-error-form>
          }
          @if (submited && form.errors?.dtArrivalRequired) {
            <app-error-form>Informe a data de Volta.</app-error-form>
          }
          @if (submited && form.errors?.periodInvalid) {
            <app-error-form>A data de Ida não pode ser maior que a data de Volta.</app-error-form>
          }
        </div>

        <div class="search-field search-field--action">
          <button class="btn-search" type="submit" [disabled]="form.invalid">
            <span class="search-icon" aria-hidden="true"></span>
            Pesquisar voos
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
